import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class TagApiService extends ApiService {
  static async getAll(params: object): Promise<IServiceResponse<any>> {
    return this.axios.get('tags', { params })
      .then((response: AxiosResponse) => response.data)
  }
}
